import React from "react";
import { Container } from "../../components/container";
import Pill from "../../components/pill/pill";

const PILLS = [
  "dining",
  "fitness",
  "pets",
  "automobile",
  "Travel",
  "hotels",
  "Beauty & WEllness",
];

function Booking() {
  return (
    <section
      className="bg-white py-10"
      id="booking"
      aria-label="In-app booking services"
    >
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <h2 className="font-ppacma text-[56px] md:text-8xl leading-[120%] max-w-[539px]">
            <span className="text-black">In-App Booking at</span>
            <br />
            <span className="text-yellow">
              Your <br className="hidden md:block" />
              Service
            </span>
          </h2>
          <div
            className="flex gap-1 flex-wrap h-auto self-end md:max-w-[342.8px] max-w-[260px]"
            role="list"
            aria-label="Available service categories"
          >
            {PILLS.map((pill) => (
              <Pill key={pill} name={pill} />
            ))}
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mt-4 md:mt-12 text-lg font-normal text-[#3E3E3E] leading-[120%]">
          <p className="align-self-start tracking-[0px] mt-6 max-w-[464px]">
            Explore a comprehensive directory of services in your area and make
            reservations with ease, all within our app. Secure a table at your
            favorite restaurant or arrange for any service you desire.
          </p>
          <img
            src={"/booking/booking-app.png"}
            alt="League Life booking app interface showing service reservations"
            loading="lazy"
            width="auto"
            height="auto"
          />
        </div>
      </Container>
    </section>
  );
}

export { Booking };
